// WS-33712: Currently running an A/B test of an interstitial to see if it helps fundraising.
import { useState, useEffect } from 'react';
import { LightBoxWrapper } from '../LightBoxWrapper';
import Interstitial from './InterstitialTemplate';

type getTrackingLinkType = typeof globalThis.window.getTrackingLink;
interface VariantEvent extends CustomEvent {
    rf: string
    title: string
    body: string
    clipboard: string
    delay: number
}
const FACEBOOK_EVENT = 'fb-ab-33712';
let variantRF:string|null = null;
let [title, body, clipboard, delay] = ['', '', '', 0];

export const delayFun = () => {
    return delay;
};

export const clipboardCopyFun = () => {
    return clipboard && clipboard != '' ? clipboard : null
}

interface FacebookShareInterstitialType {
    facebookLink: string,
    show: boolean,
    hide: () => null
}

// WS-33712: This allows for interstitials to work for the `sharebar.tag` version of facebook sharing
$('.js-share-facebook').on('click', (event) => {
    if ($('.js-variant-hack').length) {
        event.stopPropagation();
        event.preventDefault();
        // Defined in ProjectPageShareBar.
        $('.js-variant-hack')[0].click();
    }
});

export const getFacebookVariantLink = (
    getTrackingLink:getTrackingLinkType, urlToShare:string, campaign:string, pageName:string,
) => {
    const link = getTrackingLink!(urlToShare, campaign, pageName);
    if (variantRF == null) {
        console.log('No variant set');
        return link;
    }
    console.log('link', link);
    const trackerUrl = new URL(decodeURIComponent(link));
    console.log('decode', trackerUrl);
    trackerUrl.searchParams.set('rf', trackerUrl.searchParams.get('rf') + '-' + variantRF);
    console.log('updated', trackerUrl.toString());
    return encodeURIComponent(trackerUrl.toString());
};

export const FacebookShareInterstitial = ({
    show, hide, facebookLink,
}:FacebookShareInterstitialType) => {

    const isVariantEvent = (event: Event): event is VariantEvent => {
        return 'detail' in event;
    };

    useEffect(() => {
        function facebookEvent(event: Event) {
            // Prove that the variant is a VariantTypes before setting it.
            if (isVariantEvent(event) && 'rf' in event.detail) {
                console.log('A/B test update', event.detail);
                variantRF = event.detail.rf;
                title = event.detail.title;
                body = event.detail.body;
                clipboard = event.detail.clipboard;
                delay = event.detail.delay
            }
        }
        window.addEventListener(FACEBOOK_EVENT, facebookEvent);

        return () => window.removeEventListener(FACEBOOK_EVENT, facebookEvent);
    }, []);

    // Sets lightbox content if show is true and the variant has content
    let content = null;
    if (show && body && title && facebookLink) {
        content = <Interstitial link={facebookLink} body={body} title={title} />;
    }

    return (content !== null && <LightBoxWrapper fixed={true} unMountHandler={hide}>
        {content}
    </LightBoxWrapper>);
};
